export function generateMobileDeLink(car) {
  if (!car || !car.make || !car.model) {
    return null;
  }

  const params = new URLSearchParams();
  
  params.append('cn', 'DE');
  params.append('con', 'USED');
  params.append('isSearchRequest', 'true');
  params.append('s', 'Car');
  params.append('vc', 'Car');
  params.append('sb', 'rel');
  params.append('od', 'down');
  params.append('ref', 'srp');
  params.append('refId', '867fc1d1-edfa-e009-364e-14afeb2f005b');

  if (car.year) {
    params.append('fr', `${car.year}:${car.year}`);
  }

  if (car.mileage && car.mileage > 0) {
    const mileageMin = Math.max(0, Math.round(car.mileage * 0.9));
    const mileageMax = Math.round(car.mileage * 1.1);
    params.append('ml', `${mileageMin}:${mileageMax}`);
  }

  const makeModel = `${car.make}+${car.model}`.toLowerCase().replace(/\s+/g, '+');
  params.append('ms', `;;;${makeModel}`);

  if (car.transmission) {
    const transmissionMap = {
      'AUTOMATIC': 'AUTOMATIC_GEAR',
      'AUTOMATIK': 'AUTOMATIC_GEAR',
      'MANUAL': 'MANUAL_GEAR',
      'MANUELL': 'MANUAL_GEAR',
      'SCHALTGETRIEBE': 'MANUAL_GEAR'
    };
    const transmission = transmissionMap[car.transmission.toUpperCase()] || car.transmission.toUpperCase();
    if (transmission === 'AUTOMATIC_GEAR' || transmission === 'MANUAL_GEAR') {
      params.append('tr', transmission);
    }
  }

  if (car.equipment && Array.isArray(car.equipment) && car.equipment.length > 0) {
    const equipmentNames = car.equipment
      .map(eq => {
        if (typeof eq === 'string') {
          return eq;
        }
        if (eq && typeof eq === 'object') {
          return eq.name || eq.id;
        }
        return null;
      })
      .filter(Boolean)
      .map(name => String(name).toLowerCase().replace(/\s+/g, '+').replace(/[^a-z0-9+]/g, ''));
    
    if (equipmentNames.length > 0) {
      params.append('q', equipmentNames.join('+'));
    }
  }

  const baseUrl = `https://suchen.mobile.de/fahrzeuge/search.html`;
  
  return `${baseUrl}?${params.toString()}`;
}

